export const OktaClientId = '0oa15aymctiioGwei697'
export const ENV = 'syrdt' as string
export const OVERSIGHT_ENV_NAME = 'oversight'
export const GCS_ENV_NAME = 'syrdt'
export const SUBDOMAIN_SUFFIX = 'gcs'
